module.exports = __webpack_public_path__ + "img/american express.bf5ac3b0.svg";